import React, {FC, ReactNode} from 'react'
import {LoadingState} from '../../../../global'

type PropsIsLoading = {
  alignItems: 'start' | 'center';
  children: ReactNode;
  loading: LoadingState;
  slice: number;
  height?: string
}
const IsLoading: FC<PropsIsLoading> = ({alignItems, children, loading, height, slice}) => {

  const array = [
    {width: 'w-100'},
    {width: 'w-75'},
    {width: 'w-25'},
    {width: 'w-100'},
    {width: 'w-100'},
    {width: 'w-25'},
  ]

  return (
    <>
      {
        loading !== 'fulfilled' ? (
          <div className={`w-100 d-flex justify-content-center align-items-${alignItems} flex-column`}>
            {
              array.slice(0, slice).map(({width}, index) => (
                <div className={`bg-light-dark mb-3 ${width} ${height ? height : 'h-30px'}`}
                     key={index}/>
              ))
            }
          </div>
        ) : children
      }

    </>
  )
}

export {IsLoading}